import React from 'react';
import PropTypes from 'prop-types';
import CommonModal from './Modal';
import Button from '../../Button/Button';
import NewEditContactModal from '../../Contacts/NewEditContactModal';

export default {
  title: 'Components/Modals/CommonModal',
  component: CommonModal,
  parameters: {
    layout: 'centered',
  },
  argTypes: {
    children: { control: 'text' },
    handleClose: { action: 'handleClose' },
    title: { control: 'text' },
    boxClassName: { control: 'text' },
    titlePosition: { control: 'text' },
  },
};

const Template = (args) => <CommonModal {...args} />;

export const DefaultModal = Template.bind({});
DefaultModal.args = {
  title: 'Default Modal',
  children: 'This is a default modal. You can put any content here.',
  boxClassName: 'w-2/5',
  handleClose: () => {}, // This is just a placeholder function for Storybook.
  className: 'py-3.5',
};

export const LeftHeaderModal = Template.bind({});
LeftHeaderModal.args = {
  title: 'Default Modal',
  children: 'This is a default modal. You can put any content here.',
  boxClassName: 'w-2/5',
  handleClose: () => {}, // This is just a placeholder function for Storybook.
  titlePosition: 'left',
  headerClassName: 'p-4',
};

export const ConfirmCancelModal = Template.bind({});
ConfirmCancelModal.args = {
  title: 'Are you sure you wish to cancel these changes?',
  children:
  <div className="flex space-x-4 justify-center">
    <Button label="No" size="md" color="secondary" className="px-6" />
    <Button label="Yes" size="md" className="px-6" />
  </div>,
  boxClassName: 'w-2/5',
  handleClose: () => {}, // This is just a placeholder function for Storybook.
  isHeaderDivider: false,
  titleStyle: 'text-lg',
};

export const NewContact = Template.bind({});
NewContact.args = {
  title: 'Create Contact',
  titlePosition: 'left',
  className: 'py-0',
  headerClassName: 'h-18.5 pl-5.5',
  titleStyle: 'text-2xl font-bold',
  children: <NewEditContactModal />,
  boxClassName: 'w-1/2',
  handleClose: () => {}, // This is just a placeholder function for Storybook.
  isHeaderDivider: true,
};

CommonModal.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  boxClassName: PropTypes.string,
  titlePosition: PropTypes.string,
  className: PropTypes.string,
};
